'use client';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function Loading() {
    return (
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0f1e' }}>
            <ProgressSpinner style={{ width: '48px', height: '48px' }} strokeWidth="3" fill="transparent" animationDuration=".5s" />
        </div>
    );
}
